import { useState } from 'react'

// @mui components
import { Button, Dialog, DialogTitle, DialogContent, Stack } from '@mui/material'

// formik components
import { Formik, Form } from 'formik'
import Textfield from 'components/FormsUI/Textfield'
import * as Yup from 'yup'

import RulesBox from './RulesBox';

export default function AddProfileDialog({
  close,
  existingNames,
  open,
  submit,
}){
  console.log('AddProfileDialog')

  const [rules, setRules] = useState([])

  const INITIAL_FORM_STATE = {
    name: '',
    rules: [],
  }

  const FORM_VALIDATION = Yup.object().shape({
    name: Yup.string()
      .required('Required')
      .test(
        'Unique',
        'Name already exists',
        async name => {
          if(existingNames.includes(name)){
            return false;
          }
          return true;
        }
      ),
    rules: Yup.array()
      .of(
        Yup.object().shape({
          operator: Yup.string().required('Operator Required'),
          numberValue: Yup.array()
            .of(Yup.number())
            .min(1, 'Must have at least one value')
            .required('Value Required'),
          backgroundColor: Yup.string().required('Background Color Required'),
          // color: Yup.string().required('Text Color Required')
        })
      )
      .min(1, 'Must have at least one rule')
  })

  function handleSubmit(values){
    submit(values)
    close()
  }

  function handleCancel(){
    setRules([])
    close()
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
    >
      <DialogTitle
        variant='subtitle2'
      >
        Add Threshold Profile
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={INITIAL_FORM_STATE}
          validationSchema={FORM_VALIDATION}
          onSubmit={(values) => { handleSubmit(values)}}
        >
          {
            formik => {
              const { isValid, dirty, errors } = formik

              return (
                <Form>
                  <Stack 
                    direction='column'
                    spacing={2}
                    sx={{
                      mt: 2
                    }}
                  >
                    <Textfield 
                      name='name'
                      label='Profile Name'
                    />
                    <RulesBox 
                      rules={ formik.values.rules }
                      setRules={ (newRules) => formik.setFieldValue('rules', newRules)}
                    />
                    
                    <Stack
                      direction='row'
                      justifyContent='flex-end'
                      spacing={2}
                    >
                      <Button
                        variant='contained'
                        onClick={ handleCancel }
                        sx={{
                          width: 100
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant='contained'
                        type='submit'
                        disabled={
                          !(dirty && isValid)
                        }
                        sx={{
                          width: 100
                        }}
                      >
                        Submit
                      </Button>
                    </Stack>
                    <div>
                      {console.log('errors', errors)}
                    </div>
                  </Stack>
                </Form>
              )
            }
          }          
        </Formik>
      </DialogContent>
    </Dialog>
  )
}



